import { useRecoilCallback } from 'recoil';
var nexus = {};
export default function RecoilNexus() {
    nexus.get = useRecoilCallback(function (_a) {
        var snapshot = _a.snapshot;
        return function (atom) {
            return snapshot.getLoadable(atom).contents;
        };
    }, []);
    nexus.getPromise = useRecoilCallback(function (_a) {
        var snapshot = _a.snapshot;
        return function (atom) {
            return snapshot.getPromise(atom);
        };
    }, []);
    nexus.set = useRecoilCallback(function (_a) {
        var set = _a.set;
        return set;
    }, []);
    nexus.reset = useRecoilCallback(function (_a) {
        var reset = _a.reset;
        return reset;
    }, []);
    return null;
}
export function getRecoil(atom) {
    return nexus.get(atom);
}
export function getRecoilPromise(atom) {
    return nexus.getPromise(atom);
}
export function setRecoil(atom, valOrUpdater) {
    nexus.set(atom, valOrUpdater);
}
export function resetRecoil(atom) {
    nexus.reset(atom);
}
//# sourceMappingURL=RecoilNexus.js.map